import { Directive, ElementRef, HostListener, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[inputMask]'
})
export class InputMaskDirective {

  constructor(private el: ElementRef) { }

  originalEntry = '';
  maskType: any;

  maskingCharacter = decodeURI("%E2%80%A2");

  @Input('inputMask') maskToApply: any;

  //Take the input value on blur event and apply masking technique specified on the directive
  @HostListener('blur', ["$event.target.value"]) onblur(value) {
    this.originalEntry = this.el.nativeElement.value;
    this.applyMask(this.maskToApply);
  }

  //Remove mask when input element back in focus
  @HostListener('focus') onfocus() {
    if(this.el.nativeElement.value){
    	this.removeMask(this.maskToApply);
    }
  }

  //Return Mask function based on mask type specified on the input directive
  private getMask(type) {
    switch (type) {
      case "password":
        return this.maskPassword;
      case "routingNumber":
        return this.maskAllExceptLastFour;
      case "loginId":
        return this.maskMiddle;
      case "full":
        return this.maskFull;
      case 'accountNumber':
        return this.maskAllExceptLastFour;
      case 'all_except_last_four':
        return this.maskAllExceptLastFour;
      default:
        return null;
    }
  }

  private removeMask(maskToApply) {
    //replace the masked value back to the original value
    if(this.originalEntry) {
      this.el.nativeElement.value = this.originalEntry;
    }
  }

  // Applies the mask
  private applyMask(maskToApply) {
    // Make sure we have the latest mask
    this.maskType = this.getMask(this.maskToApply);

    // Get the value from the host component
    let inputValue = this.el.nativeElement.value;
    
    if (inputValue && inputValue !== null && inputValue !== '') {
      try { 
        this.el.nativeElement.value = this.maskType(inputValue);
        // if(this.el.nativeElement.type === 'password') {
        //   this.el.nativeElement.type ='text';
        // }
      }
      catch (e) {
        this.el.nativeElement.value = inputValue;
      }
    }
    this.el.nativeElement.setAttribute('masked', true);
  }

  // MASKING FUNCTIONS

  //Removes entry once back in focus. Does NOT apply input masking
  maskPassword() {
    let inputValue = this.el.nativeElement.value;
    return inputValue;
  }

  //Angular UI team function. Includes validation
  maskCVV () {
    let inputValue = this.el.nativeElement.value;
    var isnum = /^\d+$/.test(inputValue);
    if (inputValue.length <= 3 && isnum) {
    }
    return inputValue.replace(/./g, '*');
  }

  //Masks entire user input. Applied on blur
  maskFull(){
    let inputValue = this.el.nativeElement.value;
    let maskedValue = inputValue.replace(/./g, '*');
    return maskedValue;
  }

  //Masks middle of user input. Applied on blur
  maskMiddle() {
    let inputValue = this.el.nativeElement.value;
    let length = inputValue.length;
    if(length >= 3) {
      if(length <= 6) {
        if(length = 3) {
          let hide = inputValue.slice(1, -1).replace(/./g, '*');
          let maskedValue = inputValue.slice(0, 1) + hide + inputValue.slice(-1);
          return maskedValue;
        }
        let showFirst = inputValue.slice(0, 1);
        let showLast = inputValue.slice(-1);
        let hide = inputValue.slice(1, -1).replace(/./g, '*');
        let maskedValue = showFirst + hide + showLast;
        return maskedValue;
      } else {
        let showFirst = inputValue.slice(0, 2);
        let showLast = inputValue.slice(-2);
        let hide = inputValue.slice(2, -2).replace(/./g, '*');
        let maskedValue = showFirst + hide + showLast;
        return maskedValue;
      }
    } else {
      return inputValue;
    }
  }

  //Masks Routing/Credit/Debit number
  maskAllExceptLastFour() {
    let inputValue = this.el.nativeElement.value;
    if(inputValue.length < 4 ) {
      return inputValue;
    } else {
      let maskedValue = inputValue.slice(0, -4).replace(/./g, this.maskingCharacter) + inputValue.slice(-4);
      return maskedValue;
    }
  }

  ngAfterViewInit() {
    this.originalEntry = this.el.nativeElement.value;
    this.applyMask(this.maskToApply);
  }
}
